























































































import Vue from 'vue';
import _ from 'lodash';

import { Exame } from '../../../../back/src/entity/Exame';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ResultadosDeExamesFormEdit from './ResultadosDeExamesFormEdit.vue';
import ResultadosDeExamesFormRemover from './ResultadosDeExamesFormRemover.vue';

export default Vue.extend({
  name: 'ResultadosDeExamesTabelaPedidos',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    ResultadosDeExamesFormEdit,
    ResultadosDeExamesFormRemover,
  },
  props: {
    exames: {
      type: Array as () => Exame[],
    },
    resultadosDeExames: {
      type: Array as () => ResultadoDeExame[],
    },
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
  },
  data() {
    return {
      dialogLancaResultadoDeExame: false,
      dialogRemoveResultadoDeExame: false,
      resultadoSelecionado: null,
      headers: [
        {
          value: 'id',
          text: 'Exame ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'usuario_created_by.nome',
          text: 'Solicitado por',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'created',
          text: 'Solicitado em',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'observacoes',
          text: 'Observações ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Ações ',
          class: 'text-no-wrap',
          sortable: false,
          width: '0',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    countExamesOutros(): number {
      const countExamesOutros = _.countBy(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => (!resultado.exame_id),
      );
      return countExamesOutros.true;
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
  },
  methods: {
    atualizaResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('atualizaResultadoDeExame', resultadoDeExame);
      this.dialogLancaResultadoDeExame = false;
    },
    removeResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('removeResultadoDeExame', resultadoDeExame);
      this.dialogRemoveResultadoDeExame = false;
    },
    lancaResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.resultadoSelecionado = resultadoDeExame;
      this.dialogLancaResultadoDeExame = true;
    },
    removePedidoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.resultadoSelecionado = resultadoDeExame;
      this.dialogRemoveResultadoDeExame = true;
    },
  },
});
